<div class="question-carousel__container">
  <empathy-cards-form></empathy-cards-form>
  <empathy-choices-form></empathy-choices-form>
</div>
